import $ from 'jquery';
import 'slick-carousel';
import bundles from './bundles.js';
import winners from './winners.js';
import campaigns from './campaigns.js';
import { open } from './../libs/tabs.js';
import { setupJackpot } from './jackpot-render.js';

function setupGallery() {
	const $exploreContainer = $('#section1');
	$exploreContainer.find('.gallery').each(function slickGallery() {
		const $cells = $(this).find('.gallery__cell');
		let galleryLength = $cells.length;

		if (galleryLength > 0 ) {
			$(this).slick({
				lazyLoad: 'ondemand',
				slidesToShow: 2,
				variableWidth: true,
				arrows: false,
				mobileFirst: true,
				initialSlide: 1,
				infinite: true
			});
			// we make sure we have minimum of 4 items on bundles
			// in order for the carousels to work properly

			let i = 0;

			while (galleryLength < 4) {
				$(this).slick('slickAdd', $cells[i % $cells.length].outerHTML);
				galleryLength += 1;
				i += 1;
			}
		}
	});


	// we unhide the carousels because they are initialized at this point
		// and get rid of the loading div
	$exploreContainer.find('.winner-carousel, .bundle-carousel').each(function unHideCarousel() {
			$(this).find('.spinner').remove();
			$(this).find('.gallery').removeClass('u-hide');
		});
	}

	function destroy() {
		const $exploreContainer = $('#section1');
		$exploreContainer.find('.gallery').each(function slickGallery() {
			const $slickItem = $(this);
			if ($slickItem.hasClass('slick-initialized')) {
				$slickItem.slick('unslick');
			}
		});
	}

	function init(exploreElement) {
		setupJackpot(exploreElement);
		setupGallery();
		bundles.moveBundles();
		winners.setupWinnerItems();
		campaigns.setHandlersForCampaigns();
		open('section1');
	}

	export { init, destroy };



// WEBPACK FOOTER //
// ./mobile-core/src/casino/explore.js